import ErpPalletList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/pallets") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpPalletList();
    }
}